module.exports = __webpack_public_path__ + "media/assets/images/flags/na-8f4151a48aa3de93d15825a21a5b74dd.svg";